export const iconFontAwesomeScienceDisease = (
	<i className="fa-solid fa-disease"></i>
);
